import { render, staticRenderFns } from "./CustomerInformation.vue?vue&type=template&id=4b7e273a&scoped=true"
import script from "./CustomerInformation.vue?vue&type=script&lang=ts"
export * from "./CustomerInformation.vue?vue&type=script&lang=ts"
import style0 from "./CustomerInformation.vue?vue&type=style&index=0&id=4b7e273a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7e273a",
  null
  
)

export default component.exports